import useMemory from '~/prix/react/hooks/memory'
import filesize from 'filesize'

const MemoryInformation = () => {
  const { memory, memoryError } = useMemory()

  return (
    <>
      <h2>Memória</h2>
      <div className='information'>
        <h3>Tamanho limite (JS heap):</h3>
        <span>
          {memoryError || !memory ? 'Não suportado' : filesize(memory.jsHeapSizeLimit as number)}
        </span>
      </div>
      <div className='information'>
        <h3>Tamanho total (JS heap):</h3>
        <span>
          {memoryError || !memory ? 'Não suportado' : filesize(memory.totalJSHeapSize as number)}
        </span>
      </div>
      <div className='information'>
        <h3>Memória usada (JS heap):</h3>
        <span>
          {memoryError || !memory ? 'Não suportado' : filesize(memory.usedJSHeapSize as number)}
        </span>
      </div>
    </>
  )
}

export default MemoryInformation
